import type { ModelData } from '../../types'

export const nemoVisAVis: { [key: string]: ModelData } = {
  'nemo-2-duo': {
    id: 'nemo-2-duo',
    name: 'NEMO 2 DUO',
    power: '16 kW',
    type: 'wodny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/nemo-2-duo.jpg',
    emailSubject: 'Zapytanie - NEMO 2 DUO',
    description: 'Wkład wodny dwustronny vis-a-vis 16 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto. Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 11610, 
        double: 12900, 
        triple: 14400
      },
      lift: { 
        single: 14560, 
        double: 16750, 
        triple: 17450
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 360,
          'flush-30': 410,
          'recessed-15': 450,
          'recessed-30': 530,
          'recessed-15-45': 560
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 430,
          'recessed-lift-30': 500,
          'recessed-lift-5': 950
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '16 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '4,0-6,0 kW',
      waterCapacity: '30 dm³',
      glassSize: '655 x 465 mm (obie strony)',
      insertSize: '758 x 1174-1313 x 520 mm',
      fireplaceSize: '435 x 550 x 325 mm',
      maxLogLength: '550 mm',
      weight: '224 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 2 DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 2 DUO w konfiguracji:\n\nModel: NEMO 2 DUO\nMoc: 16 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto. Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-4-duo': {
    id: 'nemo-4-duo',
    name: 'NEMO 4 DUO',
    power: '21 kW',
    type: 'wodny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/nemo-4-duo.jpg',
    emailSubject: 'Zapytanie - NEMO 4 DUO',
    description: 'Wkład wodny dwustronny vis-a-vis 21 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto. Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 12950, 
        double: 14450, 
        triple: 16050
      },
      lift: { 
        single: 15890, 
        double: 18250, 
        triple: 18940
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 390,
          'flush-30': 430,
          'recessed-15': 500,
          'recessed-30': 560,
          'recessed-15-45': 630
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 450,
          'recessed-lift-30': 530,
          'recessed-lift-5': 990
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '22 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '5,5-9,0 kW',
      waterCapacity: '50 dm³',
      glassSize: '717 x 471 mm (obie strony)',
      insertSize: '820 x 1177-1299 x 695 mm',
      fireplaceSize: '438 x 612 x 475 mm',
      maxLogLength: '600 mm',
      weight: '287 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 4 DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 4 DUO w konfiguracji:\n\nModel: NEMO 4 DUO\nMoc: 21 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto. Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-9-duo': {
    id: 'nemo-9-duo',
    name: 'NEMO 9 DUO',
    power: '20 kW',
    type: 'wodny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/nemo-9-duo.jpg',
    emailSubject: 'Zapytanie - NEMO 9 DUO',
    description: 'Wkład wodny dwustronny vis-a-vis 20 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto. Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 14770, 
        double: 16700, 
        triple: 19050
      },
      lift: { 
        single: 17710, 
        double: 20920, 
        triple: 21990
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 420,
          'flush-30': 500,
          'recessed-15': 550,
          'recessed-30': 640,
          'recessed-15-45': 690
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 510,
          'recessed-lift-30': 580,
          'recessed-lift-5': 1100
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '19 kW',
      efficiency: '89,0%',
      energyClass: 'A+',
      waterHeaterPower: '5,5-8,0 kW',
      waterCapacity: '50 dm³',
      glassSize: '904 x 454 mm (obie strony)',
      insertSize: '957 x 1360-1515 x 508 mm',
      fireplaceSize: '415 x 807 x 310 mm',
      maxLogLength: '600 mm',
      weight: '340 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 9 DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 9 DUO w konfiguracji:\n\nModel: NEMO 9 DUO\nMoc: 20 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto. Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  }
}
